/*
    Renders basic shared UI, such as the top right bar or bottom left bar, as well as initial load UI like welcome scene
    and pop up, and transition into first scene. Global UI that persists across rooms such probably be placed here
 */

import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import Welcome from './welcome/Welcome.jsx';
import PromoPage from './welcome/PromoPage.jsx';
import Logo from './Logo.jsx';
import TopBarRight from './TopBarRight.jsx';
import BottomBarRight from './BottomBarRight.jsx';
import BottomBarLeft from './BottomBarLeft.jsx';
import {
    getEntranceAutoTransitionAysnc,
    getSceneIds,
    getAllSceneInfoDictAsync,
    getStoreSelectorExistAsync,
    getStoreId,
    getCurrentLiveUserCountAsync
} from '../../utils/StoreConfigManager.js';
import { LiveChatButtonClicked } from '../../utils/Analytics';
import { getAutoRotate, getTopRightBarToBottomLeftBar } from '../../utils/EmbedVariable';
import { isMobileDevice } from '../../utils/DeviceDetector';
import { getCurrentSceneName } from '../../utils/StaticAssetManager.js';

import { AppContext } from '../../AppContext.jsx';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';
import { FlatImageSceneContext } from '../flat-image-scene/FlatImageSceneContextComponent'
import './TopUILayer.css';
import { EntranceAnimationContext } from '../entrance-animation/EntranceAnimationContextComponent';
import I18NextContext from './i18next-context/I18NextContext.jsx';
import WelcomeModal from './welcome/welcome-modal/WelcomeModal.jsx';

const autoRotate = getAutoRotate();
const moveTopRightBarToBottomLeft = getTopRightBarToBottomLeftBar();
const isMobile = isMobileDevice();
const updateUserCountInterval = 10000;

/*
    Renders basic shared UI, such as the top right bar or bottom left bar, as well as initial load UI like welcome scene
    and pop up, and transition into first scene. Global UI that persists across rooms should probably be placed here
 */

class TopUILayer extends Component {
    constructor(props) {
        super(props);
        this.hideUserPanel = this.hideUserPanel.bind(this);
        this.onWelcomeHide = this.onWelcomeHide.bind(this);
        this.toggleTipPanel = this.toggleTipPanel.bind(this);
        this.initStoreScene = this.initStoreScene.bind(this);
        this.toggleUserPanel = this.toggleUserPanel.bind(this);

        this.consentInterval = createRef();
        this.consentStatusCheckInterval = false;
        this.initPowerfrontChatModule = false;

        this.state = {
            showingWelcome: this.initStoreScene(),
            hasStoreSelector: false,
            showingTipsMenu: false,
            sharePanelOpen: false,
            userPanelOpen: false,
            userCount: null
        };

        this.autoTranstionToSceneIndex = 0;
    }

    componentDidMount() {
        getEntranceAutoTransitionAysnc()
            .then(autoTransition => {
                this.autoTranstionEntrance = autoTransition
            })
            .catch(error => console.error(error));

        getStoreSelectorExistAsync()
            .then(hasStoreSelector => this.setState({ hasStoreSelector: hasStoreSelector }))
            .catch(error => console.error(error));

        // this.getUserCount()
        // setInterval(this.getUserCount, update   UserCountInterval)

        if (this.props.setRoomObjectVisibility) {
            this.props.setRoomObjectVisibility(true);
        }
        const sceneName = getCurrentSceneName()
        console.log("disconnect", sceneName);
        if (sceneName != 'check-in' && sceneName != '') {
            this.props.setShowHotspotVisibility(true)
        }



        // START - consent first before initiating powerfront chat widget
        const getCookie = (name) => {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        }
        
        const consentIntervalForPowerfrontChat = () => {
            this.consentInterval.current = setInterval(
                ()=> {
                    const cookieItem = getCookie('FRG_profiling');
                    const getTrackingPermission = cookieItem && cookieItem === "yes";
                    
                    if (this.consentStatusCheckInterval && !this.initPowerfrontChatModule && this.props.currentLanguage !== 'kor_kr') {
                        // runs module script once when user consents
                        powerfrontChatModule();
                        this.initPowerfrontChatModule = true;
                        setTimeout(()=>{
                            const chatElem = document.getElementById('inside_liveChatTab');
                            if (chatElem) {
                                chatElem.addEventListener('click', LiveChatButtonClicked);
                            }
                        },6500)
                    } else {
                        if (getTrackingPermission) this.consentStatusCheckInterval = true
                    }
                }
            , 1000)
        }
    
        const powerfrontChatModule = () => {
            (function(u,t,d) {
                var i=d.createElement(t);
                i.type='text/javascript';
                i.async=true;
                i.src=u;
                var s=d.getElementsByTagName(t)[0];
                s.parentNode.insertBefore(i,s);
            })('https://eu2-track.inside-graph.com/gtm/IN-1000927-VS/include.js','script',document);
        }
        
    
        consentIntervalForPowerfrontChat();
        //clears checking for consent after 30s if the user does not consent
        setTimeout(()=> {
            clearInterval(this.consentInterval.current);
            this.consentInterval.current = null;
        }, 30000)

        // END - consent first before initiating powerfront chat widget        
    }

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if (prevProps.showingUI !== this.props.showingUI) {
    //         this.props.setLoadingIconVisibility(false);
    //     }
    // }


    initStoreScene() {
        const dragTooltipEncountered = sessionStorage.getItem('dragTooltipEncountered')
        // If drag tooltip has been shown this session, show the tooltip
        if (!dragTooltipEncountered) {
            return true;
        }

        this.props.setRoomObjectVisibility(true);
        this.props.setShowHotspotVisibility(true)
        return false;
    }

    onWelcomeHide() {
        const { connectController } = this.props.threeJSWorldContext;
        this.setState({ showingWelcome: false });

        this.props.setShowHotspotVisibility(true);
        connectController();

        if (this.autoTranstionEntrance > 0) {
            this.props.setLoadingIconVisibility(true);
            let linkedRoomId = '';
            getSceneIds()
                .then(sceneIds => {
                    linkedRoomId = sceneIds[1];
                    return getAllSceneInfoDictAsync();
                })
                .then(sceneInfoDict => {
                    const sceneInfo = sceneInfoDict[linkedRoomId];
                    const linkedRoomName = sceneInfo['name'];
                    const targetPath = '/' + linkedRoomName;
                    this.props.history.push(targetPath);
                })
                .catch(error => console.error(error));
        }
    }

    toggleTipPanel(isShowing) {
        this.setState({
            showingTipsMenu: isShowing
        });
    }

    toggleUserPanel() {
        this.setState({
            sharePanelOpen: false,
            userPanelOpen: !this.state.userPanelOpen
        });
    }

    hideUserPanel() {
        this.setState({
            userPanelOpen: false
        })
    }

    // GETs current active user count in mall. 
    // Currently set to be fired off every 10 seconds.
    // While using the same endpoint as mall, payload is different, location is set to storeId instead.
    // getUserCount() {
    //     getCurrentLiveUserCountAsync(getStoreId())
    //         .then(userCount => {
    //             this.setState({ userCount })
    //         })
    //         .catch(err => console.error(err));
    // }

    getFlatImageSceneWelcomeComponent() {
        const { isFlatImageScene, flatImageButtonOption, flatImageButtonText } = this.props.flatImageSceneContextValue;
        return <Welcome
            showingUI={true}
            onWelcomeHide={this.onWelcomeHide}
            isFlatImageScene={isFlatImageScene}
            flatImageButtonOption={flatImageButtonOption}
            flatImageButtonText={flatImageButtonText}
            setShowWelcomeModal={this.props.setShowWelcomeModal}
        />
    }

    getWelcomeComponent() {
        const { showingUI,setShowWelcomeModal } = this.props;
        const { showingWelcome } = this.state;
        const { isFlatImageScene } = this.props.flatImageSceneContextValue;

        if (isFlatImageScene) {
            return this.getFlatImageSceneWelcomeComponent();
        }

        if (showingWelcome) {
            if (autoRotate) {
                return <PromoPage
                    onWelcomeHide={this.onWelcomeHide}
                />
            }
            return <Welcome
                showingUI={showingUI}
                onWelcomeHide={this.onWelcomeHide}
                setShowWelcomeModal={setShowWelcomeModal}
            />
        }
    }

    getBottomBarLeft() {
        if (this.state.showingTipsMenu && isMobile) {
            return <React.Fragment />;
        }
        return <BottomBarLeft
            showSocial={this.state.hasStoreSelector}
            toggleUserPanel={this.toggleUserPanel}
            userPanel={this.state.userPanelOpen}
            userCount={this.state.userCount}
            isMobile={isMobile}
            hideUserPanel={this.hideUserPanel}
        />;
    }

    getLogo() {
        const {showHotspots} = this.props;
        if(showHotspots){
            return this.props.hideLogo ? <React.Fragment /> : <Logo currentLanguage={this.props.currentLanguage} currentSceneName={this.props.currentSceneName} />
        }
    }

    showWelcomeBox = () => {
        const { showWelcomeModal } = this.props;
        const { showingWelcome } = this.state;
        let welcomeBox = null;
        if (showWelcomeModal == 1 && !showingWelcome) {
            welcomeBox = <WelcomeModal />
        }
        return welcomeBox
    }

    getTopBarRight() {
        const { setQuizVisibility } = this.props;
        this.state.hasStoreSelector = true;
        return <TopBarRight showStoreSelector={this.state.hasStoreSelector}
            moveTopRightBarToBottomLeft={moveTopRightBarToBottomLeft}
            setQuizVisibility={setQuizVisibility}
            currentLanguage={this.props.currentLanguage}
            currentSceneName={this.props.currentSceneName} />;
    }

    getTopUILayer() {
        return (
            <div id="top-layer-ui-container" >
                {this.getWelcomeComponent()}
                {this.showWelcomeBox()}
                {this.getLogo()}
                {this.getTopBarRight()}
                <BottomBarRight toggleTipPanel={this.toggleTipPanel} />
                {this.getBottomBarLeft()}
            </div>
        )
    }

    render() {
        if (!this.props.showingUI || (!this.props.isAnimationVideoEnd && this.props.isEntranceAnimationScene)) {
            return <React.Fragment />;
        }
        return this.getTopUILayer();
    }
}

TopUILayer.propTypes = {
    history: PropTypes.object,
    hideLogo: PropTypes.bool,
    showingUI: PropTypes.bool,
    setRoomObjectVisibility: PropTypes.func,
    setLoadingIconVisibility: PropTypes.func,
    threeJSWorldContext: PropTypes.object,
    setQuizVisibility:propTypes.func,
    setShowWelcomeModal:propTypes.func
};

export default props => (
    <AppContext.Consumer>
        {appContextValue => (
            <ThreeJSWorldContext.Consumer>
                {threeJSWorldContextValue => (
                    <FlatImageSceneContext.Consumer>
                        {flatImageSceneContextValue => (
                            <EntranceAnimationContext.Consumer>
                                {entranceAnimationContext => (
                                    <I18NextContext.Consumer>
                                        {i18Props => (
                                            <TopUILayer
                                                {...props}
                                                history={threeJSWorldContextValue.history}
                                                setLoadingIconVisibility={appContextValue.setLoadingIconVisibility}
                                                threeJSWorldContext={threeJSWorldContextValue}
                                                primaryColor={appContextValue.primaryColor}
                                                flatImageSceneContextValue={flatImageSceneContextValue}
                                                isAnimationVideoEnd={entranceAnimationContext.isAnimationVideoEnd}
                                                isEntranceAnimationScene={entranceAnimationContext.isEntranceAnimationScene}
                                                setQuizVisibility={appContextValue.setQuizVisibility}
                                                currentLanguage={i18Props.currentLanguage}
                                                currentSceneName={appContextValue.currentSceneName}
                                                showWelcomeModal={appContextValue.showWelcomeModal}
                                                setShowWelcomeModal={appContextValue.setShowWelcomeModal}
                                                setShowHotspotVisibility={appContextValue.setShowHotspotVisibility}
                                                showHotspots={appContextValue.showHotspots}
                                            />
                                        )}
                                    </I18NextContext.Consumer>
                                )}
                            </EntranceAnimationContext.Consumer>
                        )}
                    </FlatImageSceneContext.Consumer>
                )}
            </ThreeJSWorldContext.Consumer>
        )}
    </AppContext.Consumer>
);